import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import list from './linked-retailers/list';

const linkedRetailers = combineReducers({
  list,
  isSaving: loadingStatusAccordingToReducer('linkedRetailersSavingStatus'),
  isLoading: loadingStatusAccordingToReducer('linkedRetailersLoadingStatus'),
});

export default linkedRetailers;



// WEBPACK FOOTER //
// ./src/modules/user/reducers/linked-retailers.reducer.js